// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== Posters / carousel section ===== */
.posters-section {
  max-width: 1400px; /* Increased from 1200px */
  margin: 0 auto;
  /* Small top padding so it sits close under the Flexible Learning Modes card */
  padding: 16px 24px 56px;
  text-align: center;
}

.posters-heading h2 {
  font-size: clamp(1.6rem, 3vw, 2.2rem);
  font-weight: 700;
  color: #1e2a4a;
  margin: 0 0 40px; /* Increased from 8px to 40px for more space below heading */
}

.posters-heading p {
  color: #5b6478;
  margin: 0 0 32px;
  font-size: 1rem;
}

/* Shared carousel height on desktop (both panels match) */
:root {
  --carousel-desktop-height: min(70vh, 480px);
}

/* Container for two carousels side by side */
.poster-carousel-container {
  display: flex;
  gap: 32px; /* Increased from 24px for better spacing */
  justify-content: space-between;
  align-items: flex-start;
}

.poster-carousel-wrapper {
  flex: 1;
  min-width: 0; /* allows flex items to shrink below content size */
}

/* Mobile: Stack carousels vertically */
@media (max-width: 768px) {
  .poster-carousel-container {
    flex-direction: column;
    gap: 24px;
  }
  
  .poster-carousel-wrapper {
    width: 100%;
  }
}

/* Carousel layout: viewport with overlaid arrows */
.poster-carousel {
  position: relative; /* For absolute positioning of arrows */
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%; /* Take full width */
}

/* No fixed box — the viewport takes the natural height of the poster image.
   Width is capped on desktop; height follows whatever the image's ratio is. */
.poster-viewport {
  width: 100%;
  max-width: 100%; /* Changed from 560px to allow side-by-side layout */
  overflow: hidden;
  border-radius: 16px;
  box-shadow: 0 12px 32px rgba(30, 42, 74, 0.18);
}

/* Track width must match viewport so each slide is exactly one panel wide */
.poster-track {
  display: flex;
  width: 100%;
  transition: transform 0.45s ease;
}

.poster-slide {
  flex: 0 0 100%;
  width: 100%;
  min-width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  overflow: hidden;
}

.poster-slide img {
  width: 100%;
  height: auto; /* image keeps its own aspect ratio — no crop, no bars */
  display: block;
  user-select: none;
}

/* Video slide (YouTube intro), shown as the last slide after the posters. */
.poster-slide--video {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #000;
  width: 100%;
  height: 100%;
}

/* Instagram slide styling */
.poster-slide--instagram {
  display: flex;
  align-items: stretch;
  justify-content: center;
  background: #fafafa;
  overflow: hidden;
  position: relative;
}

/* Instagram post card - vertical 4:5 ratio, balanced on desktop */
.instagram-post-card {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  background: #fff;
  position: relative;
  min-height: 0;
}

.poster-slide--instagram .instagram-post-card {
  min-height: 0;
}

/* Media area: full image/video visible, room for native controls */
.instagram-post-media {
  flex: 1;
  min-height: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #000;
  overflow: hidden;
}

/* Hover expansion for carousel post items - NO FLICKERING */
.carousel-post-item {
  position: relative;
  z-index: 1;
  overflow: visible;
}

.carousel-post-item img.instagram-post-image,
.carousel-post-item .carousel-video {
  width: 100%;
  height: 100%;
  max-height: 100%;
  min-height: 0;
  object-fit: contain;
  object-position: center;
  display: block;
  background: transparent;
  transition: none;
  pointer-events: auto;
}

.carousel-video {
  background: #000;
  cursor: default;
  max-height: calc(100% - 4px);
}

.carousel-post-item video {
  pointer-events: auto !important;
}

/* Let the browser render native video controls — do not override webkit pseudo-elements */
.instagram-post-link {
  position: relative;
  flex-shrink: 0;
  margin: 12px auto 16px;
  padding: 10px 20px;
  background: linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%);
  color: #fff;
  text-decoration: none;
  border-radius: 24px;
  font-size: 0.9rem;
  font-weight: 600;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
  transition: all 0.3s ease;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  max-width: 90%; /* Prevent overflow on small screens */
  backdrop-filter: blur(8px); /* Better readability over images */
}

.instagram-post-link:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.3);
}

@media (max-width: 768px) {
  .instagram-post-link {
    padding: 9px 18px;
    font-size: 0.85rem;
    margin: 10px auto 14px;
    max-width: 85%;
  }
}

@media (max-width: 480px) {
  .instagram-post-link {
    padding: 8px 14px;
    font-size: 0.75rem;
    margin: 8px auto 12px;
    max-width: 80%;
  }

  .instagram-post-link svg {
    width: 12px;
    height: 12px;
    margin-right: 4px !important;
  }
}

/* Instagram fallback card - when no image available */
.instagram-fallback-card {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
}

.instagram-fallback-header {
  padding: 16px 20px;
  display: flex;
  align-items: center;
  gap: 12px;
  border-bottom: 1px solid #efefef;
  background: #fafafa;
}

.instagram-fallback-header svg {
  color: #e4405f;
}

.instagram-fallback-header span {
  font-weight: 600;
  color: #262626;
  font-size: 0.95rem;
}

.instagram-fallback-body {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #fafafa 0%, #fff 100%);
}

.instagram-fallback-image-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  color: #8e8e8e;
}

.instagram-fallback-image-placeholder svg {
  opacity: 0.3;
}

.instagram-fallback-image-placeholder p {
  margin: 0;
  font-size: 0.9rem;
  color: #8e8e8e;
}

.instagram-fallback-link {
  margin: 20px;
  padding: 14px 24px;
  background: linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%);
  color: #fff;
  text-decoration: none;
  border-radius: 24px;
  font-size: 0.9rem;
  font-weight: 600;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
  text-align: center;
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.instagram-fallback-link:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.3);
}

/* Responsive fallback button */
@media (max-width: 768px) {
  .instagram-fallback-link {
    margin: 16px;
    padding: 12px 20px;
    font-size: 0.85rem;
  }
}

@media (max-width: 480px) {
  .instagram-fallback-link {
    margin: 12px;
    padding: 10px 16px;
    font-size: 0.8rem;
  }
}

/* Remove old embed styles - not needed anymore */
.instagram-embed-container {
  display: none;
}

.poster-video {
  width: 100%;
  height: 100%;
  border: 0;
  display: block;
}

.poster-video-shell {
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9;
  overflow: hidden;
  background: #000;
  contain: layout paint;
}

.poster-video-shell .poster-video {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  aspect-ratio: unset;
  min-height: unset;
}

.poster-swipe-edge {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 22%;
  z-index: 5;
  touch-action: none;
}

.poster-swipe-edge--left {
  left: 0;
}

.poster-swipe-edge--right {
  right: 0;
}

.poster-video-placeholder {
  width: 100%;
  aspect-ratio: 16 / 9;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);
}

.poster-video-placeholder img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

/* YouTube carousel: natural 16:9 on phones/tablets */
@media (max-width: 768px) {
  .poster-carousel-wrapper--youtube .poster-viewport {
    height: auto;
  }
}

/* Prev / next arrows - positioned absolutely over the carousel */
.poster-nav {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
  width: 40px; /* Smaller than before */
  height: 40px;
  border-radius: 50%;
  border: none;
  background: rgba(42, 26, 58, 0.85); /* Semi-transparent */
  color: #fff;
  font-size: 1.5rem;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s ease, transform 0.2s ease;
  box-shadow: 0 4px 12px rgba(30, 42, 74, 0.35);
}

.poster-nav.prev {
  left: 8px; /* Position from left edge */
}

.poster-nav.next {
  right: 8px; /* Position from right edge */
}

.poster-nav:hover {
  background: rgba(74, 42, 90, 0.95);
  transform: translateY(-50%) scale(1.1);
}

.poster-nav.prev:hover {
  transform: translateY(-50%) scale(1.1);
}

.poster-nav.next:hover {
  transform: translateY(-50%) scale(1.1);
}

.poster-nav:active {
  transform: translateY(-50%) scale(0.95);
}

/* Dots */
.poster-dots {
  display: flex;
  justify-content: center;
  gap: 12px; /* Increased from 10px */
  margin-top: 20px; /* Reduced from 24px to bring dots closer to carousel */
}

.poster-dot {
  width: 12px; /* Increased from 10px */
  height: 12px; /* Increased from 10px */
  border-radius: 50%;
  border: none;
  padding: 0;
  background: #c9cdda;
  cursor: pointer;
  transition: background 0.2s ease, transform 0.2s ease;
}

.poster-dot.active {
  background: #2a1a3a;
  transform: scale(1.25);
}

/* Instagram Expanded Modal */
.instagram-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.85);
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.instagram-modal-content {
  position: relative;
  max-width: 550px;
  max-height: 95vh;
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 25px 80px rgba(0, 0, 0, 0.6);
  display: flex;
  flex-direction: column;
  animation: slideUp 0.3s ease;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.instagram-modal-close {
  position: absolute;
  top: 16px;
  right: 16px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: none;
  background: rgba(0, 0, 0, 0.7);
  color: #fff;
  font-size: 24px;
  cursor: pointer;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  backdrop-filter: blur(8px);
}

.instagram-modal-close:hover {
  background: rgba(0, 0, 0, 0.9);
  transform: scale(1.1);
}

.instagram-modal-media {
  width: 100%;
  height: auto;
  max-height: 85vh;
  object-fit: contain; /* Show full post without cropping */
  display: block;
  background: #000;
}

.instagram-modal-link {
  padding: 16px 24px;
  background: linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%);
  color: #fff;
  text-decoration: none;
  font-size: 0.95rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.instagram-modal-link:hover {
  background: linear-gradient(45deg, #e08323 0%, #d5582c 25%, #cc1733 50%, #bc1356 75%, #ac0878 100%);
}

/* Responsive modal */
@media (max-width: 768px) {
  .instagram-modal-content {
    max-width: 90vw;
  }
  
  .instagram-modal-media {
    max-height: 80vh;
  }
}

@media (max-width: 480px) {
  .instagram-modal-overlay {
    padding: 10px;
  }
  
  .instagram-modal-content {
    max-width: 95vw;
    border-radius: 12px;
  }
  
  .instagram-modal-close {
    width: 36px;
    height: 36px;
    font-size: 20px;
    top: 12px;
    right: 12px;
  }
  
  .instagram-modal-link {
    padding: 14px 20px;
    font-size: 0.85rem;
  }
}

/* ===== Desktop: side-by-side, matched balanced height ===== */
@media (min-width: 769px) {
  .poster-carousel-container {
    align-items: stretch;
  }

  .poster-carousel-wrapper {
    display: flex;
    flex-direction: column;
  }

  .poster-carousel {
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  /* Both carousels share the same height box */
  .poster-carousel-wrapper--instagram .poster-viewport,
  .poster-carousel-wrapper--youtube .poster-viewport {
    flex: 1;
    width: 100%;
    height: var(--carousel-desktop-height);
    max-height: var(--carousel-desktop-height);
    aspect-ratio: unset;
  }

  .poster-carousel-wrapper--instagram .poster-track,
  .poster-carousel-wrapper--instagram .poster-slide,
  .poster-carousel-wrapper--instagram .instagram-post-card,
  .poster-carousel-wrapper--youtube .poster-track,
  .poster-carousel-wrapper--youtube .poster-slide,
  .poster-carousel-wrapper--youtube .poster-slide--video {
    height: 100%;
  }

  .poster-carousel-wrapper--youtube .poster-video-shell {
    width: 100%;
    height: 100%;
    aspect-ratio: unset;
    min-height: unset;
  }

  .poster-carousel-wrapper--youtube .poster-video-placeholder {
    width: 100%;
    height: 100%;
    aspect-ratio: unset;
    min-height: unset;
  }
}

/* ===== Phone / tablet: stacked, natural sizing (unchanged behaviour) ===== */
@media (max-width: 768px) {
  .poster-carousel-wrapper--instagram .poster-viewport {
    height: auto;
    max-height: none;
    aspect-ratio: unset;
  }

  .carousel-post-item img.instagram-post-image,
  .carousel-post-item .carousel-video {
    height: auto;
    max-height: none;
  }

  .instagram-post-card {
    height: auto;
  }
}

@media (max-width: 640px) {
  .posters-section {
    padding: 40px 16px;
  }

  .poster-carousel-container {
    flex-direction: column;
    gap: 32px;
  }

  .poster-nav {
    display: none;
  }

  .poster-viewport {
    max-width: 100%;
    border-radius: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/frontend/components/PosterCarousel/poster-carousel.css"],"names":[],"mappings":"AAAA,2CAA2C;AAC3C;EACE,iBAAiB,EAAE,0BAA0B;EAC7C,cAAc;EACd,8EAA8E;EAC9E,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,cAAc;EACd,gBAAgB,EAAE,4DAA4D;AAChF;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA,0DAA0D;AAC1D;EACE,2CAA2C;AAC7C;;AAEA,6CAA6C;AAC7C;EACE,aAAa;EACb,SAAS,EAAE,2CAA2C;EACtD,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,OAAO;EACP,YAAY,EAAE,mDAAmD;AACnE;;AAEA,uCAAuC;AACvC;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,mDAAmD;AACnD;EACE,kBAAkB,EAAE,uCAAuC;EAC3D,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW,EAAE,oBAAoB;AACnC;;AAEA;8EAC8E;AAC9E;EACE,WAAW;EACX,eAAe,EAAE,oDAAoD;EACrE,gBAAgB;EAChB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA,4EAA4E;AAC5E;EACE,aAAa;EACb,WAAW;EACX,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,eAAe;EACf,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY,EAAE,wDAAwD;EACtE,cAAc;EACd,iBAAiB;AACnB;;AAEA,4EAA4E;AAC5E;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;EACX,YAAY;AACd;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,kEAAkE;AAClE;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA,mEAAmE;AACnE;EACE,OAAO;EACP,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,4DAA4D;AAC5D;EACE,kBAAkB;EAClB,UAAU;EACV,iBAAiB;AACnB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,uBAAuB;EACvB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;AACjC;;AAEA,0FAA0F;AAC1F;EACE,kBAAkB;EAClB,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,mGAAmG;EACnG,WAAW;EACX,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,0CAA0C;EAC1C,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc,EAAE,sCAAsC;EACtD,0BAA0B,EAAE,mCAAmC;AACjE;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE;IACE,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;IACtB,cAAc;EAChB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;IACrB,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,4BAA4B;EAC9B;AACF;;AAEA,sDAAsD;AACtD;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0DAA0D;AAC5D;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,mGAAmG;EACnG,WAAW;EACX,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,yCAAyC;EACzC,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA,+BAA+B;AAC/B;EACE;IACE,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;EACnB;AACF;;AAEA,iDAAiD;AACjD;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,UAAU;EACV,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,6DAA6D;AAC/D;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA,qDAAqD;AACrD;EACE;IACE,YAAY;EACd;AACF;;AAEA,iEAAiE;AACjE;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,WAAW,EAAE,wBAAwB;EACrC,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kCAAkC,EAAE,qBAAqB;EACzD,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qDAAqD;EACrD,6CAA6C;AAC/C;;AAEA;EACE,SAAS,EAAE,4BAA4B;AACzC;;AAEA;EACE,UAAU,EAAE,6BAA6B;AAC3C;;AAEA;EACE,kCAAkC;EAClC,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,uCAAuC;AACzC;;AAEA,SAAS;AACT;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS,EAAE,wBAAwB;EACnC,gBAAgB,EAAE,uDAAuD;AAC3E;;AAEA;EACE,WAAW,EAAE,wBAAwB;EACrC,YAAY,EAAE,wBAAwB;EACtC,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,eAAe;EACf,qDAAqD;AACvD;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA,6BAA6B;AAC7B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,+BAA+B;EAC/B,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,8BAA8B;EAC9B,WAAW;EACX,eAAe;EACf,eAAe;EACf,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,mBAAmB,EAAE,oCAAoC;EACzD,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mGAAmG;EACnG,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,mGAAmG;AACrG;;AAEA,qBAAqB;AACrB;EACE;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,SAAS;IACT,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;AACF;;AAEA,+DAA+D;AAC/D;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,OAAO;IACP,aAAa;IACb,sBAAsB;EACxB;;EAEA,6CAA6C;EAC7C;;IAEE,OAAO;IACP,WAAW;IACX,sCAAsC;IACtC,0CAA0C;IAC1C,mBAAmB;EACrB;;EAEA;;;;;;IAME,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;EACnB;AACF;;AAEA,8EAA8E;AAC9E;EACE;IACE,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;;IAEE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;AACF","sourcesContent":["/* ===== Posters / carousel section ===== */\r\n.posters-section {\r\n  max-width: 1400px; /* Increased from 1200px */\r\n  margin: 0 auto;\r\n  /* Small top padding so it sits close under the Flexible Learning Modes card */\r\n  padding: 16px 24px 56px;\r\n  text-align: center;\r\n}\r\n\r\n.posters-heading h2 {\r\n  font-size: clamp(1.6rem, 3vw, 2.2rem);\r\n  font-weight: 700;\r\n  color: #1e2a4a;\r\n  margin: 0 0 40px; /* Increased from 8px to 40px for more space below heading */\r\n}\r\n\r\n.posters-heading p {\r\n  color: #5b6478;\r\n  margin: 0 0 32px;\r\n  font-size: 1rem;\r\n}\r\n\r\n/* Shared carousel height on desktop (both panels match) */\r\n:root {\r\n  --carousel-desktop-height: min(70vh, 480px);\r\n}\r\n\r\n/* Container for two carousels side by side */\r\n.poster-carousel-container {\r\n  display: flex;\r\n  gap: 32px; /* Increased from 24px for better spacing */\r\n  justify-content: space-between;\r\n  align-items: flex-start;\r\n}\r\n\r\n.poster-carousel-wrapper {\r\n  flex: 1;\r\n  min-width: 0; /* allows flex items to shrink below content size */\r\n}\r\n\r\n/* Mobile: Stack carousels vertically */\r\n@media (max-width: 768px) {\r\n  .poster-carousel-container {\r\n    flex-direction: column;\r\n    gap: 24px;\r\n  }\r\n  \r\n  .poster-carousel-wrapper {\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n/* Carousel layout: viewport with overlaid arrows */\r\n.poster-carousel {\r\n  position: relative; /* For absolute positioning of arrows */\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 100%; /* Take full width */\r\n}\r\n\r\n/* No fixed box — the viewport takes the natural height of the poster image.\r\n   Width is capped on desktop; height follows whatever the image's ratio is. */\r\n.poster-viewport {\r\n  width: 100%;\r\n  max-width: 100%; /* Changed from 560px to allow side-by-side layout */\r\n  overflow: hidden;\r\n  border-radius: 16px;\r\n  box-shadow: 0 12px 32px rgba(30, 42, 74, 0.18);\r\n}\r\n\r\n/* Track width must match viewport so each slide is exactly one panel wide */\r\n.poster-track {\r\n  display: flex;\r\n  width: 100%;\r\n  transition: transform 0.45s ease;\r\n}\r\n\r\n.poster-slide {\r\n  flex: 0 0 100%;\r\n  width: 100%;\r\n  min-width: 100%;\r\n  max-width: 100%;\r\n  box-sizing: border-box;\r\n  overflow: hidden;\r\n}\r\n\r\n.poster-slide img {\r\n  width: 100%;\r\n  height: auto; /* image keeps its own aspect ratio — no crop, no bars */\r\n  display: block;\r\n  user-select: none;\r\n}\r\n\r\n/* Video slide (YouTube intro), shown as the last slide after the posters. */\r\n.poster-slide--video {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background: #000;\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n/* Instagram slide styling */\r\n.poster-slide--instagram {\r\n  display: flex;\r\n  align-items: stretch;\r\n  justify-content: center;\r\n  background: #fafafa;\r\n  overflow: hidden;\r\n  position: relative;\r\n}\r\n\r\n/* Instagram post card - vertical 4:5 ratio, balanced on desktop */\r\n.instagram-post-card {\r\n  width: 100%;\r\n  height: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: stretch;\r\n  justify-content: flex-start;\r\n  background: #fff;\r\n  position: relative;\r\n  min-height: 0;\r\n}\r\n\r\n.poster-slide--instagram .instagram-post-card {\r\n  min-height: 0;\r\n}\r\n\r\n/* Media area: full image/video visible, room for native controls */\r\n.instagram-post-media {\r\n  flex: 1;\r\n  min-height: 0;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background: #000;\r\n  overflow: hidden;\r\n}\r\n\r\n/* Hover expansion for carousel post items - NO FLICKERING */\r\n.carousel-post-item {\r\n  position: relative;\r\n  z-index: 1;\r\n  overflow: visible;\r\n}\r\n\r\n.carousel-post-item img.instagram-post-image,\r\n.carousel-post-item .carousel-video {\r\n  width: 100%;\r\n  height: 100%;\r\n  max-height: 100%;\r\n  min-height: 0;\r\n  object-fit: contain;\r\n  object-position: center;\r\n  display: block;\r\n  background: transparent;\r\n  transition: none;\r\n  pointer-events: auto;\r\n}\r\n\r\n.carousel-video {\r\n  background: #000;\r\n  cursor: default;\r\n  max-height: calc(100% - 4px);\r\n}\r\n\r\n.carousel-post-item video {\r\n  pointer-events: auto !important;\r\n}\r\n\r\n/* Let the browser render native video controls — do not override webkit pseudo-elements */\r\n.instagram-post-link {\r\n  position: relative;\r\n  flex-shrink: 0;\r\n  margin: 12px auto 16px;\r\n  padding: 10px 20px;\r\n  background: linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%);\r\n  color: #fff;\r\n  text-decoration: none;\r\n  border-radius: 24px;\r\n  font-size: 0.9rem;\r\n  font-weight: 600;\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);\r\n  transition: all 0.3s ease;\r\n  z-index: 10;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  white-space: nowrap;\r\n  max-width: 90%; /* Prevent overflow on small screens */\r\n  backdrop-filter: blur(8px); /* Better readability over images */\r\n}\r\n\r\n.instagram-post-link:hover {\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.3);\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .instagram-post-link {\r\n    padding: 9px 18px;\r\n    font-size: 0.85rem;\r\n    margin: 10px auto 14px;\r\n    max-width: 85%;\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .instagram-post-link {\r\n    padding: 8px 14px;\r\n    font-size: 0.75rem;\r\n    margin: 8px auto 12px;\r\n    max-width: 80%;\r\n  }\r\n\r\n  .instagram-post-link svg {\r\n    width: 12px;\r\n    height: 12px;\r\n    margin-right: 4px !important;\r\n  }\r\n}\r\n\r\n/* Instagram fallback card - when no image available */\r\n.instagram-fallback-card {\r\n  width: 100%;\r\n  height: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  background: #fff;\r\n  border-radius: 12px;\r\n  overflow: hidden;\r\n}\r\n\r\n.instagram-fallback-header {\r\n  padding: 16px 20px;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  border-bottom: 1px solid #efefef;\r\n  background: #fafafa;\r\n}\r\n\r\n.instagram-fallback-header svg {\r\n  color: #e4405f;\r\n}\r\n\r\n.instagram-fallback-header span {\r\n  font-weight: 600;\r\n  color: #262626;\r\n  font-size: 0.95rem;\r\n}\r\n\r\n.instagram-fallback-body {\r\n  flex: 1;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background: linear-gradient(135deg, #fafafa 0%, #fff 100%);\r\n}\r\n\r\n.instagram-fallback-image-placeholder {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 12px;\r\n  color: #8e8e8e;\r\n}\r\n\r\n.instagram-fallback-image-placeholder svg {\r\n  opacity: 0.3;\r\n}\r\n\r\n.instagram-fallback-image-placeholder p {\r\n  margin: 0;\r\n  font-size: 0.9rem;\r\n  color: #8e8e8e;\r\n}\r\n\r\n.instagram-fallback-link {\r\n  margin: 20px;\r\n  padding: 14px 24px;\r\n  background: linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%);\r\n  color: #fff;\r\n  text-decoration: none;\r\n  border-radius: 24px;\r\n  font-size: 0.9rem;\r\n  font-weight: 600;\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\r\n  transition: all 0.3s ease;\r\n  text-align: center;\r\n  display: block;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.instagram-fallback-link:hover {\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.3);\r\n}\r\n\r\n/* Responsive fallback button */\r\n@media (max-width: 768px) {\r\n  .instagram-fallback-link {\r\n    margin: 16px;\r\n    padding: 12px 20px;\r\n    font-size: 0.85rem;\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .instagram-fallback-link {\r\n    margin: 12px;\r\n    padding: 10px 16px;\r\n    font-size: 0.8rem;\r\n  }\r\n}\r\n\r\n/* Remove old embed styles - not needed anymore */\r\n.instagram-embed-container {\r\n  display: none;\r\n}\r\n\r\n.poster-video {\r\n  width: 100%;\r\n  height: 100%;\r\n  border: 0;\r\n  display: block;\r\n}\r\n\r\n.poster-video-shell {\r\n  position: relative;\r\n  width: 100%;\r\n  aspect-ratio: 16 / 9;\r\n  overflow: hidden;\r\n  background: #000;\r\n  contain: layout paint;\r\n}\r\n\r\n.poster-video-shell .poster-video {\r\n  position: absolute;\r\n  inset: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  aspect-ratio: unset;\r\n  min-height: unset;\r\n}\r\n\r\n.poster-swipe-edge {\r\n  position: absolute;\r\n  top: 0;\r\n  bottom: 0;\r\n  width: 22%;\r\n  z-index: 5;\r\n  touch-action: none;\r\n}\r\n\r\n.poster-swipe-edge--left {\r\n  left: 0;\r\n}\r\n\r\n.poster-swipe-edge--right {\r\n  right: 0;\r\n}\r\n\r\n.poster-video-placeholder {\r\n  width: 100%;\r\n  aspect-ratio: 16 / 9;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  overflow: hidden;\r\n  background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);\r\n}\r\n\r\n.poster-video-placeholder img {\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n  display: block;\r\n}\r\n\r\n/* YouTube carousel: natural 16:9 on phones/tablets */\r\n@media (max-width: 768px) {\r\n  .poster-carousel-wrapper--youtube .poster-viewport {\r\n    height: auto;\r\n  }\r\n}\r\n\r\n/* Prev / next arrows - positioned absolutely over the carousel */\r\n.poster-nav {\r\n  position: absolute;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  z-index: 10;\r\n  width: 40px; /* Smaller than before */\r\n  height: 40px;\r\n  border-radius: 50%;\r\n  border: none;\r\n  background: rgba(42, 26, 58, 0.85); /* Semi-transparent */\r\n  color: #fff;\r\n  font-size: 1.5rem;\r\n  line-height: 1;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition: background 0.2s ease, transform 0.2s ease;\r\n  box-shadow: 0 4px 12px rgba(30, 42, 74, 0.35);\r\n}\r\n\r\n.poster-nav.prev {\r\n  left: 8px; /* Position from left edge */\r\n}\r\n\r\n.poster-nav.next {\r\n  right: 8px; /* Position from right edge */\r\n}\r\n\r\n.poster-nav:hover {\r\n  background: rgba(74, 42, 90, 0.95);\r\n  transform: translateY(-50%) scale(1.1);\r\n}\r\n\r\n.poster-nav.prev:hover {\r\n  transform: translateY(-50%) scale(1.1);\r\n}\r\n\r\n.poster-nav.next:hover {\r\n  transform: translateY(-50%) scale(1.1);\r\n}\r\n\r\n.poster-nav:active {\r\n  transform: translateY(-50%) scale(0.95);\r\n}\r\n\r\n/* Dots */\r\n.poster-dots {\r\n  display: flex;\r\n  justify-content: center;\r\n  gap: 12px; /* Increased from 10px */\r\n  margin-top: 20px; /* Reduced from 24px to bring dots closer to carousel */\r\n}\r\n\r\n.poster-dot {\r\n  width: 12px; /* Increased from 10px */\r\n  height: 12px; /* Increased from 10px */\r\n  border-radius: 50%;\r\n  border: none;\r\n  padding: 0;\r\n  background: #c9cdda;\r\n  cursor: pointer;\r\n  transition: background 0.2s ease, transform 0.2s ease;\r\n}\r\n\r\n.poster-dot.active {\r\n  background: #2a1a3a;\r\n  transform: scale(1.25);\r\n}\r\n\r\n/* Instagram Expanded Modal */\r\n.instagram-modal-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background: rgba(0, 0, 0, 0.85);\r\n  z-index: 10000;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 20px;\r\n  animation: fadeIn 0.3s ease;\r\n}\r\n\r\n@keyframes fadeIn {\r\n  from { opacity: 0; }\r\n  to { opacity: 1; }\r\n}\r\n\r\n.instagram-modal-content {\r\n  position: relative;\r\n  max-width: 550px;\r\n  max-height: 95vh;\r\n  background: #fff;\r\n  border-radius: 16px;\r\n  overflow: hidden;\r\n  box-shadow: 0 25px 80px rgba(0, 0, 0, 0.6);\r\n  display: flex;\r\n  flex-direction: column;\r\n  animation: slideUp 0.3s ease;\r\n}\r\n\r\n@keyframes slideUp {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(30px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n.instagram-modal-close {\r\n  position: absolute;\r\n  top: 16px;\r\n  right: 16px;\r\n  width: 40px;\r\n  height: 40px;\r\n  border-radius: 50%;\r\n  border: none;\r\n  background: rgba(0, 0, 0, 0.7);\r\n  color: #fff;\r\n  font-size: 24px;\r\n  cursor: pointer;\r\n  z-index: 10;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition: all 0.2s ease;\r\n  backdrop-filter: blur(8px);\r\n}\r\n\r\n.instagram-modal-close:hover {\r\n  background: rgba(0, 0, 0, 0.9);\r\n  transform: scale(1.1);\r\n}\r\n\r\n.instagram-modal-media {\r\n  width: 100%;\r\n  height: auto;\r\n  max-height: 85vh;\r\n  object-fit: contain; /* Show full post without cropping */\r\n  display: block;\r\n  background: #000;\r\n}\r\n\r\n.instagram-modal-link {\r\n  padding: 16px 24px;\r\n  background: linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%);\r\n  color: #fff;\r\n  text-decoration: none;\r\n  font-size: 0.95rem;\r\n  font-weight: 600;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.instagram-modal-link:hover {\r\n  background: linear-gradient(45deg, #e08323 0%, #d5582c 25%, #cc1733 50%, #bc1356 75%, #ac0878 100%);\r\n}\r\n\r\n/* Responsive modal */\r\n@media (max-width: 768px) {\r\n  .instagram-modal-content {\r\n    max-width: 90vw;\r\n  }\r\n  \r\n  .instagram-modal-media {\r\n    max-height: 80vh;\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .instagram-modal-overlay {\r\n    padding: 10px;\r\n  }\r\n  \r\n  .instagram-modal-content {\r\n    max-width: 95vw;\r\n    border-radius: 12px;\r\n  }\r\n  \r\n  .instagram-modal-close {\r\n    width: 36px;\r\n    height: 36px;\r\n    font-size: 20px;\r\n    top: 12px;\r\n    right: 12px;\r\n  }\r\n  \r\n  .instagram-modal-link {\r\n    padding: 14px 20px;\r\n    font-size: 0.85rem;\r\n  }\r\n}\r\n\r\n/* ===== Desktop: side-by-side, matched balanced height ===== */\r\n@media (min-width: 769px) {\r\n  .poster-carousel-container {\r\n    align-items: stretch;\r\n  }\r\n\r\n  .poster-carousel-wrapper {\r\n    display: flex;\r\n    flex-direction: column;\r\n  }\r\n\r\n  .poster-carousel {\r\n    flex: 1;\r\n    display: flex;\r\n    flex-direction: column;\r\n  }\r\n\r\n  /* Both carousels share the same height box */\r\n  .poster-carousel-wrapper--instagram .poster-viewport,\r\n  .poster-carousel-wrapper--youtube .poster-viewport {\r\n    flex: 1;\r\n    width: 100%;\r\n    height: var(--carousel-desktop-height);\r\n    max-height: var(--carousel-desktop-height);\r\n    aspect-ratio: unset;\r\n  }\r\n\r\n  .poster-carousel-wrapper--instagram .poster-track,\r\n  .poster-carousel-wrapper--instagram .poster-slide,\r\n  .poster-carousel-wrapper--instagram .instagram-post-card,\r\n  .poster-carousel-wrapper--youtube .poster-track,\r\n  .poster-carousel-wrapper--youtube .poster-slide,\r\n  .poster-carousel-wrapper--youtube .poster-slide--video {\r\n    height: 100%;\r\n  }\r\n\r\n  .poster-carousel-wrapper--youtube .poster-video-shell {\r\n    width: 100%;\r\n    height: 100%;\r\n    aspect-ratio: unset;\r\n    min-height: unset;\r\n  }\r\n\r\n  .poster-carousel-wrapper--youtube .poster-video-placeholder {\r\n    width: 100%;\r\n    height: 100%;\r\n    aspect-ratio: unset;\r\n    min-height: unset;\r\n  }\r\n}\r\n\r\n/* ===== Phone / tablet: stacked, natural sizing (unchanged behaviour) ===== */\r\n@media (max-width: 768px) {\r\n  .poster-carousel-wrapper--instagram .poster-viewport {\r\n    height: auto;\r\n    max-height: none;\r\n    aspect-ratio: unset;\r\n  }\r\n\r\n  .carousel-post-item img.instagram-post-image,\r\n  .carousel-post-item .carousel-video {\r\n    height: auto;\r\n    max-height: none;\r\n  }\r\n\r\n  .instagram-post-card {\r\n    height: auto;\r\n  }\r\n}\r\n\r\n@media (max-width: 640px) {\r\n  .posters-section {\r\n    padding: 40px 16px;\r\n  }\r\n\r\n  .poster-carousel-container {\r\n    flex-direction: column;\r\n    gap: 32px;\r\n  }\r\n\r\n  .poster-nav {\r\n    display: none;\r\n  }\r\n\r\n  .poster-viewport {\r\n    max-width: 100%;\r\n    border-radius: 12px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
